var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unscheduled-tasks-list"},_vm._l((_vm.tasks),function(config){return _c('UnscheduledTasksListItem',{key:config.id,attrs:{"config":config,"color":(_vm.calendarsStore.getCalendarById(config.extendedProps.calendarId)).color},on:{"task-clicked":_vm.passTaskClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }